const FanVerseLogo = ({ className = "", size = 40, showText = true, light = false }) => {
  const textColor = light ? "#E2E8F0" : "#30135B";
  const subColor = light ? "#A78BFA" : "#7C4BD3";
  
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="fanverse-logo">
      <svg
        width={size}
        height={size}
        viewBox="9800 7800 5500 5000"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        <defs>
          <linearGradient id="logoStarGrad" gradientUnits="userSpaceOnUse" x1="12457.46" y1="8023.08" x2="12457.46" y2="12388.71">
            <stop offset="0" stopColor="#6B30B5" />
            <stop offset="1" stopColor="#421D80" />
          </linearGradient>
          <linearGradient id="logoSwooshGrad" gradientUnits="userSpaceOnUse" x1="10799.21" y1="10336.73" x2="14468.03" y2="10336.73">
            <stop offset="0" stopColor="#582291" />
            <stop offset="1" stopColor="#FEFEFE" />
          </linearGradient>
        </defs>

        {/* Main five-pointed star */}
        <polygon
          points="12457.46,8023.08 13039.54,9663.5 14838.71,9663.5 13383.5,10721.83 13912.67,12388.71 12457.46,11462.67 11002.25,12388.71 11531.42,10721.83 10076.21,9663.5 11875.38,9663.5"
          fill="url(#logoStarGrad)"
        />

        {/* Swoosh arc */}
        <path
          d="M11038.91 11911.01c0,0 -145.87,-70.69 -211.31,-293.75 -39.73,-135.47 -47.12,-282.93 39.85,-625.88 49.42,-194.86 271.82,-411.05 413.82,-553.41 486.15,-487.38 994.08,-735.65 1067.41,-808.98 93.51,-93.52 2119.35,-866.54 2119.35,-866.54l-1652.22 1075.5 -511.7 317.91 -511.29 381.39 -447.92 405.13c0,0 -337.18,313.98 -305.99,968.63z"
          fill="url(#logoSwooshGrad)"
        />

        {/* Small sparkle star */}
        <polygon
          points="14521.21,8552.25 14600.59,8234.75 14679.96,8552.25 14997.46,8631.62 14679.96,8711 14600.59,9028.5 14521.21,8711 14203.71,8631.62"
          fill="#8E43F2"
        />
      </svg>

      {showText && (
        <div className="flex flex-col leading-none">
          <span
            className="font-black text-xl tracking-tight"
            style={{ color: textColor, fontFamily: "'Outfit', sans-serif" }}
          >
            FANVERSE
          </span>
          <span
            className="text-[9px] tracking-[0.2em] font-medium mt-0.5"
            style={{ color: subColor }}
          >
            SINCE 2026
          </span>
        </div>
      )}
    </div>
  );
};

export default FanVerseLogo;
